import * as toastr from 'toastr';
export function shareLink(link) {
    var el = document.createElement('input');
    el.setAttribute('style', 'position: absolute; top: -10000px; left: -1000px');
    document.body.appendChild(el);
    el.value = link;
    el.select();
    el.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(el);
    toastr.success('Link Copied!');
}
//# sourceMappingURL=ShareManager.js.map